// i18n area 'system' — locale sv-SE (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.sv-SE.meta.json.
import type { enUS } from './system'

export const svSE: typeof enUS = {
  diagnostics: {
    title: 'Diagnostik',
    subtitle: 'Vad som är fel, värst först — samma lins som tvirt diagnose',
    reload: 'Ladda om',
    loadError: 'Diagnosen kunde inte läsas',
    exportBundle: 'Exportera paket',
    exportError: 'Paketet kunde inte skapas',
    noProblem: 'Inget problem i de inspekterade områdena',
    nothingInspected: 'INGENTING inspekterades — detta är inget friskintyg',
    inspected: 'Inspekterade',
    notInspected: 'INTE inspekterade',
    localHint: 'Nodens lokala områden (systemd-enheter, journal) läses bara från CLI: tvirt diagnose --area local — vägen när API:et inte svarar.',
    thresholds: 'misslyckade uppgifter inom {hours} h, heartbeat försenat över {seconds} s',
    severity: {
      critical: 'Kritisk',
      warning: 'Varning',
      unknown: 'Okänd'
    }
  },
  explorer: {
    title: 'Utforska resurser',
    root: 'Rot',
    empty: 'Inga resurser i detta scope',
    previewHint: 'Välj ett objekt för att se dess förhandsvisning',
    open: 'Öppna',
    openScoped: 'Öppna listan i detta scope',
    kinds: {
      vm: 'VM',
      vmTemplate: 'VM-template',
      ct: 'CT',
      ctTemplate: 'CT-template',
      app: 'App',
      overlayNetwork: 'Overlay-nätverk',
      networkService: 'Nätverkstjänst',
      fabric: 'Fabric',
      subnet: 'Subnät',
      storage: 'Storage-pool',
      disk: 'Disk',
      catalogFile: 'Katalogfil',
      ociRegistry: 'OCI-register',
      ociImage: 'OCI-avbild',
      cephCluster: 'Ceph-kluster',
      backupDestination: 'Backup-destination',
      user: 'Användare',
      group: 'Grupp',
      role: 'Roll',
      credential: 'Autentiseringsuppgift',
      tag: 'Tagg',
      proximityRule: 'Närhetsregel'
    }
  },
  tags: {
    title: 'Taggar',
    empty: 'Inga taggar',
    add: 'Lägg till tagg',
    remove: 'Ta bort',
    name: 'Tagg',
    value: 'Värde',
    save: 'Spara',
    saveError: 'Kunde inte spara taggarna',
    loadError: 'Kunde inte läsa in taggvokabulären',
    noVocabulary: 'Inga taggar tillgängliga för den här resurstypen',
    overwrite: 'Ersätt det nuvarande värdet',
    createTitle: 'Skapa tagg',
    editTitle: 'Redigera tagg',
    nameHint: 'Bokstäver, siffror, punkter, bindestreck och understreck — inget ":" eller "/"; prefixet tvirt- är reserverat för plattformen',
    cardinality: 'Kardinalitet',
    cardinalitySingle: 'Ett enda värde',
    cardinalityMultiple: 'Flera värden',
    cardinalityHint: 'Med ett enda värde ber en omtilldelning av taggen om att ersätta det',
    autoCreate: 'Autoskapa värden',
    autoCreateOn: 'Vid tilldelning',
    autoCreateOff: 'Endast deklarerade',
    autoCreateHint: 'På: att tilldela ett nytt värde skapar det. Av: endast deklarerade värden kan tilldelas',
    values: 'Värden',
    noValues: 'Inga deklarerade värden',
    addValue: 'Lägg till värde',
    duplicateValue: 'Duplicerat värde',
    kinds: 'Resurstyper',
    kindsAll: 'Alla',
    kindsPlaceholder: 'Alla',
    kindsHint: 'Lämna tomt för att tillåta alla taggbara resurstyper',
    systemChip: 'System',
    deleteCascade: 'Ta även bort tilldelningarna',
    deleteCascadeHint: 'En tagg som fortfarande är tilldelad någon resurs avvisas: med det här alternativet försvinner värdena och alla tilldelningar tillsammans med taggen.'
  },
  scopes: {
    title: 'Scope',
    createTitle: 'Skapa scope',
    editTitle: 'Byt namn på scope',
    path: 'Sökväg',
    segment: 'Segment',
    segmentHint: 'Gemener, siffror och bindestreck (DNS-1123)',
    parent: 'Förälder',
    rootChip: 'Rot',
    preview: 'Nytt scope',
    pickLabel: 'Scope',
    pickHint: 'Var objektet bor i klustrets träd — roten eller ett vDC inuti den.',
    ociCache: 'OCI-cache (override)',
    appEphemeral: 'Efemära app-pooler (override)',
    inherit: 'Ärv',
    inheritsFrom: 'Ärver från',
    inheritsCluster: 'Ärver klustrets standard',
    inheritsNone: 'Ärver — ingen effektiv pool',
    failoverProtection: 'Skydd i degraderat kluster',
    networkWeight: 'Nätverksvikt',
    networkCeil: 'Nätverkstak (Mbps)',
    protectionProtected: 'Skyddad',
    protectionExpendable: 'Kan offras vid degradering',
    protectionDefault: 'Klusterstandard'
  },
  sysinfo: {
    summary: 'Plattformens versioner i klustret, varje nods komponenter, administrationsmanual och licens.',
    platformTitle: 'TVirt-plattformen',
    platformSubtitle: 'Versioner observerade på klustrets noder',
    versionOnNodes: '{version} på {n} noder',
    versionOnOneNode: '{version} på 1 nod',
    mixedVersions: 'Mer än en plattformsversion i klustret — förväntat bara under en pågående uppgradering (högst två).',
    tooManyVersions: 'Mer än två plattformsversioner i klustret — det är aldrig förväntat, inte ens under en uppgradering: kontrollera noderna här nedanför.',
    unreportedNodes: 'Ännu ingen versionsrapport från: {nodes}',
    noVersionsYet: 'Ingen nod har ännu rapporterat sina versioner.',
    nodesUnavailable: 'Nodlistan är inte synlig med dina behörigheter — plattformens versioner kan inte visas.',
    colNode: 'Nod',
    manualTitle: 'Administrationsmanual',
    manualSubtitle: 'Lokal kopia, serverad från det här klustret',
    manualBody: 'Den kompletta TVirt-manualen i PDF, serverad direkt från plattformen — tillgänglig även i air-gappade miljöer.',
    manualLink: 'Administrationsmanual (PDF)',
    apiExplorerTitle: 'API-utforskare',
    apiExplorerSubtitle: 'OpenAPI-kontraktet, bläddringsbart',
    apiExplorerBody: 'Plattformens kompletta OpenAPI-kontrakt — varje rutt, schema och svarskod — utforskningsbart från webbläsaren, serverat genom denna nod.',
    apiExplorerLink: 'Utforska API:et',
    kubeTitle: 'Kubernetes-kompatibilitet',
    kubeSubtitle: 'kubectl och dess verktyg, framför det inbyggda API:et',
    kubeBody: 'TVirt KubeCompat projicerar Pods, Deployments, Services, namespaces, noder och händelser i Kubernetes-dialekten — skrivskyddat, plus borttagning av Deployments. Varje anrop går via det inbyggda API:et med dina behörigheter: använd en app-token som bearer i din kubeconfig.',
    kubeEndpoint: 'Endpoint för kubectl',
    kubeStatusActive: 'Aktiv — Kubernetes {version}',
    kubeStatusMissing: 'Inte installerad på den här noden (paketet trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Installerad men svarar inte — kontrollera enheten trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Kontrollerar…'
  },
  licensing: {
    title: 'Klustrets licens',
    subtitle: 'Prenumerationslicens — högst en per kluster',
    absentTitle: 'Ingen licens registrerad',
    absentBody:
      'Utan en giltig licens vägrar klustret att starta nya virtuella maskiner (påslagna VM förblir påslagna). Registrera den product key du fick med prenumerationen.',
    registerButton: 'Registrera licens',
    removeButton: 'Ta bort licens',
    state: {
      ok: 'Giltig',
      limitExceeded: 'Gränsen överskriden',
      expired: 'Utgången'
    },
    productKeyLabel: 'Product key',
    basisLabel: 'Gränsens bas',
    basis: {
      concurrentVms: 'Samtidigt påslagna VM',
      physicalCores: 'Fysiska kärnor (hela klustret)'
    },
    limitLabel: 'Gräns',
    usageLabel: 'Aktuell användning',
    usageOf: '{used} av {limit}',
    usagePartial: 'delsumma — {n} nod(er) utan observerad CPU-topologi',
    usageUnknown: 'inte observerbar just nu',
    expiresLabel: 'Går ut',
    neverExpires: 'aldrig',
    registeredLabel: 'Registrerad',
    gateNote:
      'Med licensen saknad, utgången eller över gränsen vägrar klustret att starta NYA virtuella maskiner. Påslagna VM förblir påslagna och HA-omstarter påverkas inte.',
    devStage:
      'Utvecklingsfas: product keyn accepteras som den är, tillsammans med de gränser som deklareras här; validering med signerad nyckel kommer i en framtida release.',
    dialogTitle: 'Registrera licens',
    dialogExpiresHelp: 'Tomt = licensen går aldrig ut',
    dialogSubmit: 'Registrera',
    dialogError: 'Kunde inte registrera licensen.',
    removeTitle: 'Ta bort licens',
    removeBody:
      'Klustret blir kvar UTAN LICENS: nya virtuella maskiner vägrar starta tills du registrerar en ny. Påslagna VM förblir påslagna.',
    removeConfirm: 'Ta bort',
    removeError: 'Kunde inte ta bort licensen.'
  },
  rbac: {
    tabRoles: 'Roller',
    tabGrants: 'Delegeringar',
    rolesTitle: 'Roller',
    createRoleTitle: 'Skapa roll',
    editRoleTitle: 'Redigera roll',
    nameHint: 'Gemener, siffror och bindestreck; prefixet tvirt- är reserverat',
    systemChip: 'System',
    permissions: 'Behörigheter',
    permissionsPlaceholder: 'Lägg till behörighet…',
    includedRoles: 'Inkluderade roller',
    includedRolesPlaceholder: 'Lägg till roll…',
    grantsTitle: 'Delegeringar',
    createGrantTitle: 'Skapa delegering',
    principal: 'Principal',
    principalKind: 'Typ av principal',
    principalUser: 'Användare',
    principalGroup: 'Grupp',
    role: 'Roll',
    grantRight: 'Delegering',
    grantRightChip: 'Kan delegera',
    grantRightLabel: 'Med delegeringsrätt (mottagaren kan i sin tur delegera den här rollen)',
    effective: 'Effektiv',
    notEffective: 'Inte effektiv',
    createdAt: 'Skapad',
    scopeHint: '/path exakt, /path/* rekursivt — delegeringar förankras i en monterad rot (/* går inte att delegera)'
  },
  groups: {
    title: 'Grupper',
    createTitle: 'Skapa grupp',
    nameHint: 'Gemener, siffror och bindestreck; unikt inom scopet',
    members: 'Medlemmar',
    membersTitle: 'Medlemmar',
    membersPlaceholder: 'Lägg till användare…',
    noMembers: 'Inga medlemmar',
    realmMappings: 'Realm-mappningar',
    realmMappingsTitle: 'Realm-mappningar',
    realmMappingsHint:
      'Vad den här gruppen motsvarar i varje externt realm. Medlemskapet läses från directoryn vid inloggningen: en directory-grupp som ingen mappar här ignoreras, och nästling löses inte upp — den måste plattas ut på directory-sidan.',
    realm: 'Realm',
    externalGroup: 'Extern grupp',
    addRealmMapping: 'Lägg till mappning',
    removeRealmMapping: 'Ta bort mappning',
    noRealmMappings: 'Inga realm-mappningar',
    sectionGeneral: 'Allmänt',
    mappingsNoRealms: 'Inget externt realm konfigurerat — mappningsytan låses upp så snart ett realm finns.',
    mappingsNoRealmsLink: 'Öppna fliken Realm och SSO',

    // MFA-kravet ålagt av gruppen (runda #178, halva B): en ren OR — en grupp
    // kan bara LÄGGA TILL kravet, aldrig lyfta det.
    mfaRequired: 'MFA-krav',
    mfaRequiredChip: 'Ålägger MFA',
    mfaNotRequiredChip: 'Inget krav',
    mfaRequiredHint:
      'Ren OR: en grupp kan LÄGGA TILL kravet på andra faktorn för sina medlemmar — även för externa identiteter, via realm-mappningarna — aldrig lyfta det. Det gäller från nästa inloggning: öppna sessioner stängs inte.'
  },
  users: {
    title: 'Användare',
    createTitle: 'Skapa användare',
    editTitle: 'Redigera användare',
    username: 'Användarnamn',
    usernameHint: 'Gemener, siffror, punkter och bindestreck',
    displayName: 'Visningsnamn',
    enabled: 'Aktiverad',
    state: 'Status',
    enabledChip: 'Aktiverad',
    disabledChip: 'Inaktiverad',
    lockedChip: 'Låst',
    password: 'Lösenord',
    passwordSetChip: 'Satt',
    mustChangeChip: 'Måste bytas',
    initialPassword: 'Initialt lösenord',
    initialPasswordHint: 'Användaren måste byta det vid första inloggningen',
    lastLogin: 'Senaste inloggning',
    neverLoggedIn: 'Har aldrig loggat in',
    setPasswordTitle: 'Sätt lösenord',
    setPasswordHint: 'Administrativ ersättning — kräver ditt lösenord (sudo-läge) och tvingar användaren att byta det vid nästa inloggning.',
    operatorPassword: 'Ditt lösenord',
    unlock: 'Lås upp kontot',
    revokeTitle: 'Återkalla sessioner',
    revokeBody: 'Alla aktiva sessioner för den här användaren avslutas omedelbart.',
    revokeIncludeTokens: 'Återkalla även app-tokens',
    revokeConfirm: 'Återkalla',
    tabAccount: 'Konto',
    tabSecurity: 'Säkerhet',
    usernameImmutableHint: 'Användarnamnet är kontots identitet — fastslaget vid skapandet',
    groups: 'Grupper',
    noGroups: 'Inga grupper',
    mustChangePassword: 'Obligatoriskt lösenordsbyte',
    failedAttempts: 'Misslyckade inloggningsförsök',
    lockedUntil: 'Låst till',
    tabUsers: 'Användare',
    tabGroups: 'Grupper',
    tabRealms: 'Realm och SSO',
    tabMfa: 'MFA',
    mfa: {
      title: 'Andra faktorn (MFA)',
      methodsTitle: 'Tillgängliga metoder',
      methodsSubtitle: 'Det den här installationen kan verifiera som andra faktor',
      methodsError: 'Kunde inte läsa in metodregistret',
      builtinChip: 'Inbyggd',
      enrollableChip: 'Enrollment i TVirt',
      delegatedChip: 'Hanteras externt',
      state: 'Status',
      stateActive: 'Aktiv',
      statePending: 'Väntar på enrollment',
      stateNone: 'Inte enrollad',
      required: 'MFA-krav',
      requiredChip: 'Obligatorisk',
      notRequiredChip: 'Inte obligatorisk',
      enrolledAt: 'Enrollment den',
      enrolledMethods: 'Enrollade metoder',
      noMethods: 'Ingen enrollment',
      codesRemaining: 'Återstående återställningskoder',
      resetTitle: 'Nollställ den andra faktorn',
      resetHint:
        'Enrollment och alla återställningskoder nollställs: vid nästa inloggning gör användaren om sin enrollment från början. MFA-kravet förblir som det är — en administratör sätter aldrig en hemlighet, utan nollställer den bara.',
      resetConfirm: 'Nollställ',
      resetError: 'Kunde inte nollställa den andra faktorn',
      empty: 'Ännu inga hanterade användare — kontona dyker upp här så snart de finns, vart och ett med sin status för den andra faktorn.',

      // Halva B (runda #178): ursprunget till det gällande kravet, externa
      // enrollments med föräldralös-status, grupper som ålägger kravet.
      viaSelf: 'Personligt',
      viaSelfHint: 'Kontots eget bidrag (dess flagga) — den enda del pennan redigerar.',
      viaGroupHint: 'Krav ärvt från den här gruppen: att ta bort den personliga flaggan friar inte användaren — man ingriper på gruppen, i fliken Grupper.',
      subject: 'Identitet',
      lastSeenAt: 'Senast bekräftad',
      enrollmentPending: 'Väntar',
      orphanChip: 'Föräldralös',
      orphanDirectoryMiss: 'Identiteten finns inte längre i directoryn',
      orphanRealmRemoved: 'Realmet togs bort från TVirt',
      orphanedAt: 'Föräldralös sedan',
      directoryUuid: 'UUID i directoryn',
      externalTitle: 'Externa enrollments',
      externalEmpty: 'Ännu ingen extern enrollment — den uppstår vid första inloggningen för en directory-identitet med MFA-krav.',
      orphanHelp:
        'En föräldralös enrollment raderar sig aldrig själv: den är säkerhetsmaterial — den stannar för auditen, och dyker identiteten upp i directoryn igen hittar den sin faktor på nytt. Den enda utvägen är den administrativa nollställningen.',
      visibilityHint: 'Externa enrollments bor i klustrets rot: bara den som har user.read över hela trädet ser dem.',
      orphanResetHint:
        'Den föräldralösa raden tas bort för gott: ingen gör anspråk på den längre. Dyker identiteten upp i directoryn igen gör den om sin enrollment från början.',
      enforcingTitle: 'Grupper som ålägger MFA',
      enforcingSubtitle:
        'Ankaret för kravet för externa identiteter är gruppen: dess realm-mappningar säger vilken directory-population det når. Den externa enrollmenten uppstår vid den ålagda användarens första inloggning.',
      enforcingEmpty: 'Ingen grupp ålägger MFA — kravet slås på på gruppen, från fliken Grupper.',
      enforcingError: 'Kunde inte läsa in grupperna som ålägger MFA'
    }
  },
  realms: {
    title: 'Autentiseringsrealm',
    createTitle: 'Skapa realm',
    editTitle: 'Redigera realm',
    name: 'Realm',
    nameHint: 'Domänen som användarna skriver efter @ (example.com) — oföränderlig efter skapandet',
    nameImmutableHint: 'Realmets namn är präglat i varje session och i varje auditrad som någonsin nämnt det — att byta namn vore att skriva om historien',
    kind: 'Typ',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC och SAML kommer i kommande rundor — i dag är ett realm en LDAPv3-directory',
    kindCategory: 'Typ av realm',
    kindSelectHint: 'Välj vilken typ av directory det här realmet ska autentisera mot.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Användarnamn och lösenord verifieras med en bind mot en LDAPv3-directory — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single sign-on från webbläsaren, delegerad till en OpenID Connect-identity provider — kommer i kommande rundor.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Single sign-on för företag med SAML 2.0-assertioner — kommer i kommande rundor.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Aktiverat',
    urls: 'Directory-servrar',
    urlsHint: 'En ldap://- eller ldaps://-URL per rad (1–8), provade i ordning — failover, aldrig lastbalansering',
    startTls: 'StartTLS',
    verifyCertificate: 'Verifiera certifikatet',
    cleartextWarning: 'Utan ldaps:// eller StartTLS färdas bind-lösenordet i klartext över nätverket — acceptabelt i labbet, aldrig i produktion.',
    noVerifyWarning: 'En overifierad TLS-session autentiserar ingen: stäng av verifieringen bara mot en directory du inte kan laga.',
    caCertificate: 'CA-certifikat (PEM)',
    caCertificateHint: 'Valfritt CA-bundle fastnålat för realmets TLS/StartTLS-handshake; tomt tar bort det',
    caCertificatePinned: 'Fastnålat',
    connectTimeout: 'Timeout (sekunder)',
    connectTimeoutHint: 'Per-URL-frist för anslutning och förfrågan (1–60); när den löper ut provas nästa URL',
    bindDn: 'Bind-DN',
    bindDnHint: 'Servicekontot som utför sökningen efter användaren; tomt = anonym search bind (avvisas av AD)',
    anonymousBind: 'Anonym search bind',
    bindCredential: 'Bind-lösenord (keystore)',
    bindCredentialHint: 'En usernamePassword-post i keystoren med bind-lösenordet — hemligheten bor aldrig på realmet',
    bindCredentialNone: 'Ingen (anonym bind)',
    bindCredentialEmpty: 'Ingen usernamePassword-post i keystoren — skapa en i System > Autentiseringsuppgifter för bind-lösenordet.',
    baseDn: 'Bas-DN',
    baseDnHint: 'Underträdet där sökningen efter användaren börjar (DC=example,DC=com)',
    userFilter: 'Användarfilter',
    userFilterHint: '%u ersätts av loginets lokala del, med RFC 4515-escape; icke-AD-directoryer vill typiskt ha (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'memberOf-attribut',
    memberOfAttributeHint: 'Läses en enda gång, vid inloggningen — omappade grupper ignoreras, nästling löses inte upp',
    uuidAttribute: 'UUID-attribut',
    uuidAttributeHint: 'Det oföränderliga UUID:t i realmet (objectGUID på AD, entryUUID på OpenLDAP) — präglat i auditen bredvid användare@realm',
    displayNameAttribute: 'Attribut för visningsnamn',
    displayNameAttributeHint: 'Används för att hälsa på användaren; saknas det används inloggningsnamnet',
    sudoHint: 'Skrivningar på realm är sudo-skyddade: ett realm är en ingång till plattformen',
    deleteBody: 'Realmets gruppmappningar följer med det bort; sessioner det har autentiserat lever kvar tills de går ut — ett raderat realm släpper helt enkelt inte in någon mer.',
    tabConnection: 'Anslutning',
    tabDirectory: 'Directory',
    testTitle: 'Testa anslutningen',
    testHint: 'En konfigurationssond, aldrig en autentisering: den ansluter, gör bind med servicekontot och — med ett användarnamn — kör användarfiltret.',
    testUsername: 'Användarnamn (valfritt)',
    testUsernameHint: 'En lokal del att köra användarfiltret på — 1 träff är det friska svaret',
    testRun: 'Kör testet',
    testError: 'Kunde inte köra sonden',
    testReachable: 'Directoryn är nåbar, service-bind accepterad',
    testUnreachable: 'Directoryn är INTE nåbar',
    matchedOne: 'Användarfiltret hittade exakt 1 post — det friska svaret.',
    matchedNone: 'Användarfiltret hittade ingen post: filtret eller bas-DN:t är fel.',
    matchedMany: 'Användarfiltret hittade {count} poster: det är inte selektivt, och inloggningar vore tvetydiga (avvisas).',
    mappingsPointer: 'Vad en extern grupp motsvarar är en egenskap hos TVirt-gruppen (dess realm-mappningar): sanningspunkten bor i fliken Grupper.',
    mappingsPointerLink: 'Öppna fliken Grupper',
    rootHomeHint: 'Identiteter från ett externt realm bor i klustrets rot, aldrig i ett vDC: behörigheter tilldelas där de behövs, med delegeringar — på gruppen eller direkt på användaren, precis som för de lokala kontona.'
  },
  credentials: {
    title: 'Autentiseringsuppgifter',
    createTitle: 'Skapa autentiseringsuppgift',
    editTitle: 'Redigera autentiseringsuppgift',
    kind: 'Typ',
    kindUsernamePassword: 'Användarnamn och lösenord',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (Ceph-identitet)',
    kindHintUsernamePassword: 'Oföränderlig. För CIFS/SMB-storage — mount-kontot vars hemlighet workern använder i mount-ögonblicket.',
    kindHintIscsiChap: 'Oföränderlig. För iSCSI CHAP-autentisering — användarnamn = CHAP-namn, secret = CHAP-hemlighet.',
    kindHintNvmeDhchap: 'Oföränderlig. För DH-HMAC-CHAP i NVMe over Fabrics — secret = DHHC-1:xx:…-bloben; användarnamnet är bara en etikett.',
    kindHintCephx: 'Oföränderlig. För Ceph-klienter — användarnamn = klientnamn (client.…), secret = base64-nyckeln.',
    kindImmutableHint: 'Typen är oföränderlig efter skapandet — att byta den innebär en ny autentiseringsuppgift.',
    username: 'Användarnamn',
    usernameChap: 'CHAP-namn',
    usernameNvme: 'Etikett',
    usernameCephx: 'Klientnamn',
    usernameHint: 'Valfritt konto som hemligheten tillhör',
    usernameHintChap: 'CHAP-namnet som initiatorn autentiserar sig med',
    usernameHintNvme: 'Används inte av transporten — en fri etikett för dina anteckningar',
    usernameHintCephx: 'cephx-klientens namn — prefixet client. tolereras',
    secret: 'Hemlighet',
    secretHint: 'Endast skrivning: används av konsumenterna, visas aldrig igen.',
    secretHintNvmeDhchap: 'Endast skrivning: DH-HMAC-CHAP-hosthemligheten i den kanoniska formen DHHC-1:xx:… — används av konsumenterna, visas aldrig igen.',
    secretHintCephx: 'Endast skrivning: cephx-nyckeln i base64 — används av konsumenterna, visas aldrig igen.',
    secretEditHint: 'Lämna tomt för att inte byta hemligheten — att fylla i fältet roterar den.',
    createdAt: 'Skapad',
    inUseError: "'{name}' refereras av konfigurationen för en storage — koppla loss den där först.",
    nameHint: 'Gemener, siffror och bindestreck (DNS-1123); unik per scope',
    rotateTitle: 'Rotera hemlighet',
    rotateHint: 'Endast skrivning: den nya hemligheten ersätter den lagrade — konsumenterna använder den vid nästa mount.',
    tabSecrets: 'Hemligheter',
    tabCertificates: 'Certifikat',
    tabAuthorities: 'Certifikatutfärdare',
    certificatesTitle: 'Certifikat',
    authoritiesTitle: 'Certifikatutfärdare',
    caCreateTitle: 'Ny CA',
    certCreateTitle: 'Nytt certifikat',
    caMode: 'Ursprung',
    caModeGenerate: 'Generera med TVirt',
    caModeImport: 'Importera (nyckel + certifikat)',
    certMode: 'Ursprung',
    certModeIssue: 'Utfärda från en CA i keystoren',
    certModeImport: 'Importera (nyckel + certifikat)',
    issuingCa: 'Utfärdande CA',
    issuingCaHint: 'Certifikatet föds i CA:ns scope, med sin parent registrerad',
    noCasHint: 'Ingen CA i keystoren — generera eller importera en först i fliken CA',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'CA:ns subject: bokstäver, siffror, mellanslag, punkt, understreck, bindestreck',
    commonNameCertHint: 'OpenVPN identifierar klienter på CN — håll det unikt per CA',
    days: 'Giltighet (dagar)',
    daysCaHint: '1–7300 dagar; 3650 (10 år) är standard',
    daysCertHint: '1–3650 dagar; 365 är standard',
    keyType: 'Nyckeltyp',
    keyTypeHint: 'EC P-256 är standard; RSA för legacy-konsumenter',
    usage: 'Användning',
    usageClient: 'Klient (clientAuth)',
    usageServer: 'Server (serverAuth)',
    usageHint: 'Den extended key usage som certifikatet utfärdas för',
    san: 'Alternativa namn (SAN)',
    sanHint: 'Kommaseparerade; bokstavliga IP blir IP:-poster, resten DNS:',
    keyPem: 'Privat nyckel (PEM)',
    keyPemHint: 'Endast skrivning: förvaras i keystoren, visas aldrig igen',
    certPem: 'Certifikat (PEM)',
    certPemHint: 'Det publika certifikatet som hör ihop med nyckeln',
    certPemCaHint: 'CA-certifikatet som hör ihop med nyckeln (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Utfärdare',
    parentCa: 'Utfärdande CA',
    parentCaImported: 'Importerat — utfärdat utanför TVirt',
    serial: 'Serienummer',
    fingerprint: 'Fingerprint (SHA-256)',
    validFrom: 'Giltigt från',
    validUntil: 'Giltigt till',
    expiry: 'Utgång',
    expired: 'Utgånget',
    expiresInDays: 'Går ut om {days} d',
    revoked: 'Återkallat',
    revokedAtLabel: 'Återkallat den',
    revokeTitle: 'Återkalla certifikat',
    revokeAction: 'Återkalla',
    revokeWarning: 'Återkallelsen är slutgiltig: serienumret hamnar i den utfärdande CA:ns CRL och varje konsument som avvisar återkallade certifikat (OpenVPN främst) kommer att avvisa det här. Det finns ingen un-revoke.',
    exportPem: 'Exportera PEM',
    exportChain: 'Exportera kedje-bundle',
    exportCrl: 'Exportera CRL',
    materialImmutableHint: 'X.509-materialet är oföränderligt — utfärda om eller importera om',
    caInUseError: "'{name}' har fortfarande levande utfärdade certifikat (eller en storage refererar till den) — återkalla eller radera dem först."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Placering, tillgänglighet och affinitet — var klustrets VM kör och om de ska vara påslagna',
    loadError: 'Proximity-panelen kräver kluster-storen — flottans tillstånd är inte nåbart just nu',
    config: {
      title: 'Konfiguration',
      subtitle: 'Placeringspolicy på klusternivå',
      save: 'Spara',
      saveError: 'Konfigurationen avvisades',
      strategy: 'Urvalsstrategi',
      strategy_leastUsedResources: 'Minst använda resurser',
      strategy_leastVms: 'Minst antal VM',
      strategy_random: 'Slumpmässig',
      strategyLeastUsedResourcesHint: 'Bland de giltiga kandidaterna: noden med mest återstående användbart RAM (observerat totalt − host-reserv − påslagna VM), med vCPU-åtagande som skiljedomare. Deterministisk vid samma data.',
      strategyLeastVmsHint: 'Bland de giltiga kandidaterna: noden med minst antal påslagna VM; lika utfall avgörs på namn. Deterministisk vid samma data.',
      strategyRandomHint: 'Likformigt slumpmässig bland de giltiga kandidaterna.',
      liveness: 'Tröskel för nodernas livstecken (sekunder)',
      livenessHint: 'En medlem som är tyst bortom tröskeln är onåbar: utesluten från placeringen och — om den inte är i underhåll — betraktad som död av HA-decidern, som stängslar in den och startar om dess HA-VM någon annanstans.',
      decider: 'HA-decider',
      deciderNone: 'ännu inte vald'
    },
    nodesTitle: 'Noder',
    nodesSubtitle: 'Livstecken och empirisk kapacitet — användbart RAM = totalt − bas − intecknat',
    nodeCol: 'Nod',
    stateCol: 'Status',
    ramCol: 'RAM (totalt − bas − intecknat)',
    usableCol: 'Användbart',
    vmsCol: 'Last',
    neverSeen: 'aldrig sedd',
    freshChip: 'nåbar',
    staleChip: 'onåbar',
    attestedChip: 'attesterad avstängd',
    ramFormula: 'totalt − bas − intecknat',
    haTitle: 'Hög tillgänglighet',
    haSubtitle: 'VM med HA-flaggan är "alltid påslagna": TVirt startar om dem efter varje icke begärt stopp — samma nod med backoff, en annan nod när deras egen dör (endast delad storage).',
    haNone: 'Ingen VM har HA-flaggan ännu — aktivera den här eller i VM:ens detaljvy.',
    haVmCol: 'Virtuell maskin',
    haStateCol: 'Status',
    haRestartsCol: 'HA-omstarter',
    haLastEventCol: 'Senaste händelse',
    haToggleCol: 'HA',
    haCrashLoop: 'kraschloop',
    haToggleError: 'HA-ändringen avvisades',
    rules: {
      title: 'Affinitetsregler',
      createTitle: 'Ny närhetsregel',
      editTitle: 'Redigera regel',
      nameHint: 'Gemener, siffror och bindestreck (DNS-etikett)',
      vms: 'Virtuella maskiner',
      vmsHint: 'Minst två VM — regeln styr var de kör i förhållande till varandra',
      type: 'Typ',
      affinity: 'Affinitet (tillsammans)',
      antiAffinity: 'Antiaffinitet (åtskilda)',
      typeAffinityHint: 'VM:arna måste köra på SAMMA nod.',
      typeAntiAffinityHint: 'VM:arna måste köra på OLIKA noder — det klassiska HA-paret.',
      mode: 'Läge',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Överträdelser avvisar operationen (start, migrering, failover) med ett talande fel.',
      modeSoftHint: 'En preferens, aldrig blockerande: en placering i strid med regeln fortsätter med en synlig varning.',
      satisfied: 'Placering',
      satisfiedYes: 'uppfylld',
      satisfiedNo: 'överträdd',
      violations: 'Överträdelser',
      noViolations: 'Inga'
    },
    events: {
      title: 'HA-händelser',
      subtitle: 'Tillgänglighetens journal — omstarter, fencing, failover och de ärliga hoppen',
      none: 'Ingenting ännu.',
      when: 'När',
      kind: 'Händelse',
      target: 'Objekt',
      detail: 'Detalj',
      kindRestarted: 'HA-omstart',
      kindGaveUp: 'kapitulation (kraschloop)',
      kindNodeAttested: 'nod instängslad',
      kindFailedOver: 'failover',
      kindNoCandidate: 'ingen kandidat',
      kindStorageLocalSkip: 'överhoppad (lokal storage)',
      kindZombieFenced: 'zombie terminerad'
    }
  }
}
